import script from "./DiscoverySummary.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoverySummary.vue?vue&type=script&setup=true&lang=js"

import "./DiscoverySummary.vue?vue&type=style&index=0&id=aa251b80&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa251b80"]])

export default __exports__